'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _objectDestructuringEmpty(obj) {
  if (obj == null) throw new TypeError("Cannot destructure undefined");
}

exports['default'] = _objectDestructuringEmpty;